module.exports = __webpack_public_path__ + "static/media/stories.c23ff95b.svg";